export default "__VITE_ASSET__Cobei1me__"